module.exports = __webpack_public_path__ + "img/error.20b1ed14.webp";